/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/GetValueByKey.ts
 * @create:      2025-07-01 13:19:46.314
 * @modify:      2025-07-11 21:19:12.929
 * @version:     6.0.0
 * @times:       8
 * @lines:       53
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { ConvertTo } from "./ConvertTo";

/**
 * Retrieves the value associated with the specified key from the given object.
 *
 * @param obj - The object from which to retrieve the value.
 * @param key - The key whose associated value is to be returned.
 * @returns The value associated with the specified key, typed as `TValue`.
 * 
 * @since 4.3.0
 * @version 2025-07-04
 */
export function GetValueByKey<TValue = unknown, TKey = string | number>(obj: unknown, key: TKey): TValue | undefined {
    if (obj && (typeof obj === "object" || typeof obj === "function")) {
        const value = ConvertTo(obj)[key];
        return ConvertTo<TValue>(value);
    }

    return undefined;
}
